import api from './api';
import { StudySession, StudyStats, Card } from '../types';

export const studyService = {
  async startSession(deckId: string, cardLimit?: number): Promise<StudySession> {
    const response = await api.post('/study/session', { deckId, cardLimit });
    return response.data;
  },

  async startQuickSession(cardLimit: number = 10): Promise<{ session: StudySession; cards: Card[] }> {
    const response = await api.post('/study/quick-session', { cardLimit });
    return response.data;
  },

  async getStudyCards(sessionId: string, cardLimit?: number, ignoreSchedule?: boolean): Promise<{ session: StudySession; cards: Card[] }> {
    const params = new URLSearchParams();
    if (cardLimit) params.append('cardLimit', cardLimit.toString());
    if (ignoreSchedule) params.append('ignoreSchedule', 'true');
    const queryString = params.toString();
    const response = await api.get(`/study/session/${sessionId}/cards${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  async submitAnswer(sessionId: string, answerData: {
    cardId: string;
    quality: number;
    timeSpent: number;
    correct?: boolean;
  }): Promise<StudySession> {
    const response = await api.patch(`/study/session/${sessionId}/answer`, answerData);
    return response.data;
  },

  async completeSession(sessionId: string, duration: number): Promise<StudySession> {
    const response = await api.patch(`/study/session/${sessionId}/complete`, { duration });
    return response.data;
  },

  async getSessionHistory(limit: number = 10): Promise<StudySession[]> {
    const response = await api.get(`/study/history?limit=${limit}`);
    return response.data;
  },

  async getStudyStats(): Promise<StudyStats> {
    const response = await api.get('/study/stats');
    return response.data;
  },

  async getDailyStats(): Promise<{
    cardsForReviewToday: number;
    newCardsAvailable: number;
    todayStudyTime: number;
    todayAccuracy: number;
    todayCardsStudied: number;
    todayCorrectAnswers: number;
  }> {
    const response = await api.get('/study/daily-stats');
    return response.data;
  },
};